var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfileDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1418_58918)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28,
    r: 27.5,
    fill: "#F7F7F8",
    stroke: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 28C32.3137 28 35 25.3137 35 22C35 18.6863 32.3137 16 29 16C25.6863 16 23 18.6863 23 22C23 25.3137 25.6863 28 29 28Z",
    fill: "#EAEBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 30C23.7557 30.0055 19.5058 34.0317 19.5 39C19.5 39.5523 19.9726 40 20.5555 40H37.4445C38.0274 40 38.5 39.5523 38.5 39C38.4942 34.0317 34.2443 30.0055 29 30Z",
    fill: "#EAEBEC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1418_58918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileDefault);
export default __webpack_public_path__ + "static/media/icon_profile_default.ee1030e5d611a302b5f5a57d7ab6443a.svg";
export { ForwardRef as ReactComponent };